export default "<app-drawing-canvas [clearCanvasAfterDrawing]=\"false\" (drawn)=\"handleDrawn($event)\"></app-drawing-canvas>\n";